import { useState, useContext, useEffect } from "react";
import {
  FaCogs,
  FaEdit,
  FaGlobe,
  FaPlusCircle,
  FaTrashAlt,
  FaUpload,
  FaCalendarAlt,
  FaUser,
  FaBriefcase,
  FaChartLine,
  FaUsers,
  FaCheck,
  FaDollarSign,
  FaFilePowerpoint,
  FaFileWord,
  FaCalculator,
  FaPrint,
  FaIdBadge,
  FaCommentDots,
} from "react-icons/fa";
import { CarriereEventsProvider, useCarriereEvents } from "contexts/CarriereEventsContext";
import CarriereChatbot from "components/app/AuditComplet/Retraite/CarriereChatbot/CarriereChatbot";
import ActionButton from "components/ui/controls/action-button/ActionButton";
import Button from "components/ui/controls/button/button";
import Column from "components/ui/layout/column/column";
import Modal from "components/ui/modal/modal";
import { AppContext } from "components/app/RemExprertProvider";
import { applyFormat } from "components/ui/ui-helpers";
import Dialogs from "components/ui/dialogs/dialogs";
import { RemExpertResultatTNS } from "components/app/Api/ResultatRemExpertTNSProvider";
import RGProvider, { RGContext } from "components/app/AuditComplet/Retraite/Parametrage/ReleveRG/RGProvider";
import AjoutPeriodePageModal from "pages/audit complet/retraite/ajout periode modal";
import AjoutRISPageModal from "pages/audit complet/retraite/ajout RIS modal";
import ParamRetraitePageModal from "pages/audit complet/retraite/parametrage retraite";
import { CalculPrestationContrat } from "components/app/Api/Retraite/ApiRetraite";
import { Menu, MenuItem } from "@mui/material";
import { AuditRetraitePptx, AuditRetraiteWord } from "components/app/Api/Rapport/ApiRapport";
import DetailRetraitePageModal from "./resultat/detailRetraitePager";
import "components/app/styles/pageTitleStyles.css";
import Row from "components/ui/layout/row/row";
import { CardBoxHeader } from "components/ui/controls/card-box/card-box";
import ResultatRemExpertSalarieProvider, { RemExpertResultatSalarie } from "components/app/Api/ResultatRemExpertSalarieProvider";
import { CorrespondanceActivite } from "components/app/RemExpertIntialState";
// Styles CSS pour l'animation
const styles = `
  @keyframes bounce {
    0%, 20%, 50%, 80%, 100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-4px);
    }
    60% {
      transform: translateY(-2px);
    }
  }
  
  /* Style de scrollbar personnalisé pour Webkit */
  .custom-scrollbar::-webkit-scrollbar {
    width: 6px;
  }
  
  .custom-scrollbar::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 10px;
  }
  
  .custom-scrollbar::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
  }
  
  .custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
  
  /* Modale RIS alignée à gauche */
  .modal-ris-left {
    justify-content: flex-start !important;
    padding-left: 20px;
  }
`;

// Injection des styles
if (typeof document !== "undefined") {
  const styleSheet = document.createElement("style");
  styleSheet.innerText = styles;
  document.head.appendChild(styleSheet);
}

// Modern Revenue Forecast Chart Component
const ModernReplacementChart = ({ resultat, context, clientConjoint }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [modalDetail, setModalDetail] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div
      style={{
        backgroundColor: "white",
        borderRadius: "16px",
        padding: "24px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        border: "1px solid #f0f0f0",
        textAlign: "center",
        height: "613px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "20px",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontSize: "14px",
            fontWeight: 600,
            color: "#374151",
          }}
        >
          Taux de remplacement
        </h3>
      </div>
      <div style={{ marginBottom: "20px" }}>
        <svg width="160" height="160" viewBox="0 0 160 160">
          {/* Background circle */}
          <circle cx="80" cy="80" r="70" fill="none" stroke="#F3F4F6" strokeWidth="8" />
          {/* Progress circle - dynamic percentage */}
          <circle
            cx="80"
            cy="80"
            r="70"
            fill="none"
            stroke="#4F46E5"
            strokeWidth="8"
            strokeDasharray="440"
            strokeDashoffset={440 - (440 * (resultat?.["Retraite" + clientConjoint].TauxRempRetraiteNetteChoixDepartRetraite || 0)) / 100}
            transform="rotate(-90 80 80)"
            strokeLinecap="round"
          />
          <text x="80" y="88" textAnchor="middle" fontSize="20px" fill="#374151" fontWeight="600">
            {applyFormat(resultat?.["Retraite" + clientConjoint].TauxRempRetraiteNetteChoixDepartRetraite, "uint", { thousands: " ", decimal: ",", unit: "%" })}
          </text>
        </svg>
      </div>
      {/* Goal cards grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "12px",
          marginBottom: "20px",
          flex: 1,
        }}
      >
        <div
          style={{
            backgroundColor: "#E8F5E9",
            borderRadius: "12px",
            padding: "12px",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "80px",
          }}
        >
          <div
            style={{
              width: "28px",
              height: "28px",
              backgroundColor: "#C8E6C9",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 6px",
            }}
          >
            <FaChartLine style={{ fontSize: "12px", color: "#2E7D32" }} />
          </div>
          <div style={{ fontSize: "11px", fontWeight: 600, color: "#1B5E20", marginBottom: "3px" }}>Trimestres Acquis</div>
          <div style={{ fontSize: "12px", fontWeight: 600, color: "#388E3C" }}>
            {context.state["TotalTrimestre" + clientConjoint]}/{resultat?.["Retraite" + clientConjoint].InfosRetraiteChoixDepart?.Infos?.DureeReference}
          </div>
        </div>
        <div
          style={{
            backgroundColor: "#eff6ff",
            borderRadius: "12px",
            padding: "12px",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "80px",
          }}
        >
          <div
            style={{
              width: "28px",
              height: "28px",
              backgroundColor: "#dbeafe",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 6px",
            }}
          >
            <FaUsers style={{ fontSize: "12px", color: "#2563eb" }} />
          </div>
          <div style={{ fontSize: "11px", fontWeight: 600, color: "#1d4ed8", marginBottom: "3px" }}>Âge Départ</div>
          <div style={{ fontSize: "12px", fontWeight: 600, color: "#3b82f6" }}>{context.state["AgeDepartRetraite" + clientConjoint]}</div>
        </div>
        <div
          style={{
            backgroundColor: "#faf5ff",
            borderRadius: "12px",
            padding: "12px",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "80px",
          }}
        >
          <div
            style={{
              width: "28px",
              height: "28px",
              backgroundColor: "#e9d5ff",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 6px",
            }}
          >
            <FaCheck style={{ fontSize: "12px", color: "#9333ea" }} />
          </div>
          <div style={{ fontSize: "11px", fontWeight: 600, color: "#7c3aed", marginBottom: "3px" }}>Date de départ</div>
          <div style={{ fontSize: "12px", fontWeight: 600, color: "#a855f7" }}>{applyFormat(context.state["DateDepartRetraiteAffichage" + clientConjoint], "date", "")}</div>
        </div>
        <div
          style={{
            backgroundColor: "#fef2f2",
            borderRadius: "12px",
            padding: "12px",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "80px",
          }}
        >
          <div
            style={{
              width: "28px",
              height: "28px",
              backgroundColor: "#fecaca",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 6px",
            }}
          >
            <FaDollarSign style={{ fontSize: "12px", color: "#dc2626" }} />
          </div>
          <div style={{ fontSize: "11px", fontWeight: 600, color: "#b91c1c", marginBottom: "3px" }}>Retraite nette mensuelle</div>
          <div style={{ fontSize: "14px", fontWeight: 700, color: "#ef4444" }}>
            {applyFormat(resultat?.["Retraite" + clientConjoint].TotalRetraiteNetteChoixDepartRetraite / 12, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          </div>
        </div>
      </div>
      {/* Première ligne - 2 boutons */}
      <div style={{ display: "flex", gap: "8px" }}>
        {/* Carte Détails - Version compacte */}
        <div
          onClick={() => setModalDetail(true)}
          style={{
            background: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
            borderRadius: "8px",
            padding: "12px",
            color: "white",
            cursor: "pointer",
            transition: "all 0.2s ease",
            position: "relative",
            overflow: "hidden",
            boxShadow: "0 2px 8px rgba(59, 130, 246, 0.3)",
            flex: "1 1 10%",
            minHeight: "60px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = "0 6px 15px rgba(59, 130, 246, 0.4)";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 2px 8px rgba(59, 130, 246, 0.3)";
          }}
        >
          {/* Mini graphiques décoratifs */}
          <div
            style={{
              position: "absolute",
              top: "6px",
              right: "8px",
              opacity: 0.2,
              display: "flex",
              gap: "2px",
              alignItems: "end",
            }}
          >
            <div style={{ width: "2px", height: "6px", background: "white", borderRadius: "1px" }}></div>
            <div style={{ width: "2px", height: "10px", background: "white", borderRadius: "1px" }}></div>
            <div style={{ width: "2px", height: "4px", background: "white", borderRadius: "1px" }}></div>
          </div>

          <div
            style={{
              background: "rgba(255,255,255,0.2)",
              borderRadius: "6px",
              padding: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <FaCalculator style={{ fontSize: "14px" }} />
          </div>
          <div>
            <div
              style={{
                textAlign: "left",
                fontWeight: "600",
                marginBottom: "2px",
              }}
            >
              Détail des calculs
            </div>
            <div
              style={{
                fontSize: "10px",
                opacity: 0.8,
                fontWeight: "400",
              }}
            >
              Trimestres et montants
            </div>
          </div>
        </div>
      </div>
      {context.state.TypeSimulation === "Audit retraite" && (
        <div style={{ marginTop: "12px" }}>
          {/* Carte Synthèse - Version compacte */}
          <div
            style={{
              background: "linear-gradient(135deg, #059669 0%, #047857 100%)",
              borderRadius: "8px",
              padding: "12px",
              color: "white",
              cursor: "pointer",
              transition: "all 0.2s ease",
              position: "relative",
              overflow: "hidden",
              boxShadow: "0 2px 8px rgba(5, 150, 105, 0.3)",
              flex: 1,
              minHeight: "60px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow = "0 6px 15px rgba(5, 150, 105, 0.4)";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 2px 8px rgba(5, 150, 105, 0.3)";
            }}
          >
            {/* Mini document décoratif */}
            <div
              style={{
                position: "absolute",
                top: "6px",
                right: "8px",
                opacity: 0.2,
                width: "12px",
                height: "15px",
                background: "white",
                borderRadius: "2px",
              }}
            >
              <div style={{ width: "8px", height: "1px", background: "#059669", margin: "3px 2px 1px 2px" }}></div>
              <div style={{ width: "6px", height: "1px", background: "#059669", margin: "1px 2px" }}></div>
            </div>

            <div
              style={{
                background: "rgba(255,255,255,0.2)",
                borderRadius: "6px",
                padding: "6px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <FaPrint style={{ fontSize: "14px" }} />
            </div>
            <div onClick={handleClick}>
              <div
                style={{
                  textAlign: "left",
                  fontWeight: "600",
                  marginBottom: "2px",
                }}
              >
                Impression
              </div>
              <div
                style={{
                  fontSize: "10px",
                  opacity: 0.8,
                  fontWeight: "400",
                }}
              >
                Editer un Word ou ppt
              </div>
            </div>
            <Menu
              id="demo-positioned-menu"
              aria-labelledby="demo-positioned-button"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            >
              <MenuItem
                onClick={() => {
                  AuditRetraitePptx(context.state, resultat).then((res) => {});
                  handleClose();
                }}
                disableRipple
              >
                <FaFilePowerpoint style={{ color: "#cc4424", marginRight: "10px" }} />
                <div style={{ paddingTop: "4px" }}> Etude simplifiée </div>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  AuditRetraiteWord(context.state, resultat).then((res) => {});
                  handleClose();
                }}
                disableRipple
              >
                <FaFileWord style={{ color: "#2c5698", marginRight: "10px" }} />
                <div style={{ paddingTop: "4px" }}> Etude complète </div>
              </MenuItem>
            </Menu>
          </div>
        </div>
      )}
      <Modal
        width="80%"
        height="82%"
        title="Details"
        icon={<FaIdBadge />}
        visible={modalDetail}
        onClose={() => {
          setModalDetail(false);
        }}
      >
        {modalDetail && resultat?.["Retraite" + clientConjoint]?.InfosRetraite && (
          <DetailRetraitePageModal
            Outil=""
            InfosRetraiteChoixDepart={resultat["Retraite" + clientConjoint].InfosRetraiteChoixDepart}
            InfosRetraite={resultat["Retraite" + clientConjoint].InfosRetraite}
            ClientConjoint={clientConjoint}
            visible={modalDetail}
            onClose={() => {
              setModalDetail(false);
            }}
          />
        )}
      </Modal>
    </div>
  );
};

// Period Card Component
const PeriodCard = ({ period, index, onEdit, onDelete, canDelete, correspondanceActivite }) => {
  const getActivityIcon = (nature) => {
    if (nature?.includes("Salarie") || nature?.includes("Fonction")) {
      return <FaBriefcase style={{ fontSize: 14, color: "#0d47a1" }} />;
    }
    return <FaUser style={{ fontSize: 14, color: "#0d47a1" }} />;
  };

  return (
    <div
      style={{
        backgroundColor: "white",
        borderRadius: "12px",
        padding: "12px 16px",
        marginBottom: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        border: "1px solid #f0f0f0",
        transition: "all 0.2s ease",
        cursor: "pointer",
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.12)";
        e.currentTarget.style.transform = "translateY(-2px)";
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)";
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
          <div
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              backgroundColor: "#e3f2fd",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "12px",
            }}
          >
            {getActivityIcon(period.Nature)}
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "4px" }}>
              <h4
                style={{
                  margin: 0,
                  fontSize: "12px",
                  fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                  fontWeight: 600,
                  color: "#333",
                  marginRight: "12px",
                }}
              >
                {correspondanceActivite[period.Nature] || "Activité non définie"}
              </h4>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "16px", marginTop: "8px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <FaCalendarAlt style={{ fontSize: 10, color: "#666" }} />
                <span
                  style={{
                    fontSize: "10px",
                    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                    color: "#666",
                  }}
                >
                  {applyFormat(period.Debut, "date", "")}
                </span>
              </div>
              <span style={{ color: "#ccc", fontSize: "10px" }}>→</span>
              <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <FaCalendarAlt style={{ fontSize: 10, color: "#666" }} />
                <span
                  style={{
                    fontSize: "10px",
                    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                    color: "#666",
                  }}
                >
                  {applyFormat(period.Fin, "date", "")}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Button
            onClick={onEdit}
            icon
            style={{
              display: "inline-flex",
              padding: "8px",
              backgroundColor: "#f0fff4",
              border: "none",
              borderRadius: "6px",
            }}
          >
            <FaEdit style={{ color: "#22c55e" }} />
          </Button>
          {canDelete && (
            <Button
              onClick={onDelete}
              icon
              style={{
                display: "inline-flex",
                padding: "8px",
                backgroundColor: "#fff5f5",
                border: "none",
                borderRadius: "6px",
              }}
            >
              <FaTrashAlt style={{ color: "#f56565" }} />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

const CarrierePage = (props) => {
  const { trackEvent, returnToMenu, toggleChatbot, setIsInModal } = useCarriereEvents();

  const context = useContext(AppContext);
  const [clientConjoint, setClientConjoint] = useState("");
  const [modalPeriodeRetr, setmodalPeriodeRetr] = useState(false);
  const [modalRISRetr, setmodalRISRetr] = useState(false);
  const [modalParamRetrOpen, setmodalParamRetrOpen] = useState(false);
  const ResultatTNS = useContext(RemExpertResultatTNS);
  const ResultatSalarie = useContext(RemExpertResultatSalarie);

  useEffect(() => {
    // if (context.state.ApiUser === true) {
    //   context.GetDateDepartRetraite("", context.state);
    //   context.GetDateDepartRetraite("Conjoint", context.state);
    // }

    if (context.state.TypeSimulation === "Audit complet") {
      const PeriodeClient = context.state["PeriodeActuelle"][0];
      const PeriodeConjoint = context.state["PeriodeActuelleConjoint"][0];
      if (PeriodeClient?.Statut === "TNS Article 62" || PeriodeClient?.Statut === "TNS individuel") {
        ResultatTNS.GetResultRemExpert(context.state, "").then((result) => {
          const ResultatRetraite = result?.ResultatRetraite ?? ResultatTNS.state.Retraite.ResultatRetraite;
          context.state.ListeContrat.forEach((contratRetraite, index) => {
            CalculPrestationContrat(context.state, "", ResultatRetraite, contratRetraite.Salaire, contratRetraite).then((Resultat) => {});
          });
        });
      } else {
        ResultatSalarie.GetResultRemExpert(context.state, "").then((result) => {
          const ResultatRetraite = result?.ResultatRetraite ?? ResultatSalarie.state.Retraite.ResultatRetraite;
          context.state.ListeContrat.forEach((contratRetraite, index) => {
            CalculPrestationContrat(context.state, "", ResultatRetraite, contratRetraite.Salaire, contratRetraite).then((Resultat) => {});
          });
        });
      }

      if (context.state.InclureConjoint === true) {
        if (PeriodeClient?.StatutConjoint !== "Aucun") {
          if (PeriodeClient?.StatutConjoint === "TNS Article 62" || PeriodeClient?.StatutConjoint === "TNS individuel") {
            ResultatTNS.GetResultRemExpert(context.state, "ConjointAssocie").then((result) => {
              const ResultatRetraite = result?.ResultatRetraite ?? ResultatTNS.state.Retraite.ResultatRetraite;
              context.state.ListeContrat.forEach((contratRetraite, index) => {
                CalculPrestationContrat(context.state, "Conjoint", ResultatRetraite, contratRetraite.Salaire, contratRetraite).then((Resultat) => {});
              });
            });
          } else {
            ResultatSalarie.GetResultRemExpert(context.state, "ConjointAssocie").then((result) => {
              const ResultatRetraite = result?.ResultatRetraite ?? ResultatSalarie.state.Retraite.ResultatRetraite;
              context.state.ListeContrat.forEach((contratRetraite, index) => {
                CalculPrestationContrat(context.state, "Conjoint", ResultatRetraite, contratRetraite.Salaire, contratRetraite).then((Resultat) => {});
              });
            });
          }
        } else {
          if (PeriodeConjoint?.Statut === "TNS Article 62" || PeriodeConjoint?.Statut === "TNS individuel") {
            ResultatTNS.GetResultRemExpert(context.state, "Conjoint").then((result) => {
              const ResultatRetraite = result?.ResultatRetraite ?? ResultatTNS.state.Retraite.ResultatRetraite;
              context.state.ListeContrat.forEach((contratRetraite, index) => {
                CalculPrestationContrat(context.state, "Conjoint", ResultatRetraite, contratRetraite.Salaire, contratRetraite).then((Resultat) => {});
              });
            });
          } else {
            ResultatSalarie.GetResultRemExpert(context.state, "Conjoint").then((result) => {
              const ResultatRetraite = result?.ResultatRetraite ?? ResultatSalarie.state.Retraite.ResultatRetraite;
              context.state.ListeContrat.forEach((contratRetraite, index) => {
                CalculPrestationContrat(context.state, "Conjoint", ResultatRetraite, contratRetraite.Salaire, contratRetraite).then((Resultat) => {});
              });
            });
          }
        }
      }
    } else {
      ResultatTNS.GetResultBilanRetraite(context.state, "").then((ResultatRetraite) => {
        context.state.ListeContrat.forEach((contratRetraite, index) => {
          CalculPrestationContrat(context.state, "", ResultatRetraite, contratRetraite.Salaire, contratRetraite).then((Resultat) => {});
        });
      });
      if (context.state.InclureConjoint === true) {
        ResultatTNS.GetResultBilanRetraite(context.state, "Conjoint").then((ResultatRetraite) => {
          context.state.ListeContratConjoint.forEach((contratRetraite, index) => {
            CalculPrestationContrat(context.state, "Conjoint", ResultatRetraite, contratRetraite.Salaire, contratRetraite).then((Resultat) => {});
          });
        });
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.ClientConjoint, context.state.AgeDepartProjection, context.state.AgeDepartProjectionConjoint, modalRISRetr, modalParamRetrOpen, modalPeriodeRetr]);

  useEffect(() => {
    if (props.ClientConjoint === "") {
      setClientConjoint("");
    } else {
      setClientConjoint("Conjoint");
    }
  }, [props.ClientConjoint]);

  useEffect(() => {
    const isAnyModalOpen = modalPeriodeRetr || modalRISRetr || modalParamRetrOpen;
    setIsInModal(isAnyModalOpen);
  }, [modalPeriodeRetr, modalRISRetr, modalParamRetrOpen, setIsInModal]);

  useEffect(() => {
    const isAnyModalOpen = modalPeriodeRetr || modalRISRetr || modalParamRetrOpen;
    setIsInModal(isAnyModalOpen);
  }, [modalPeriodeRetr, modalRISRetr, modalParamRetrOpen, setIsInModal]);

  return (
    <>
      <Column
        fill
        style={{
          backgroundColor: "#f8fafc",
          padding: "20px 0",
        }}
      >
        <Row>
          <Column fill>
            {context.state.TypeSimulation === "Audit complet" && (
              <Row>
                <Column fill>
                  <CardBoxHeader icon={<FaBriefcase />}>
                    <span>Carrière {context.state["Prenom" + clientConjoint]}</span>
                  </CardBoxHeader>
                </Column>
              </Row>
            )}
            {context.state.TypeSimulation === "Audit retraite" && (
              <div className="page-title-container">
                <div className="page-title-content">
                  <div className="page-title-icon">
                    <FaBriefcase />
                  </div>
                  <div className="page-title-text">
                    <h1>Carrière {context.state["Prenom" + clientConjoint]}</h1>
                    <p className="page-title-subtitle">Gestion des périodes et projection de retraite</p>
                  </div>
                </div>
              </div>
            )}
          </Column>
        </Row>
        {/* Contenu principal */}
        <div style={{ padding: "0 20px" }}>
          {/* Boutons d'action modernisés - au-dessus des deux cartes */}
          <div style={{ marginBottom: "20px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
              <ActionButton
                onClick={() => {
                  trackEvent("RIS", "MODAL_OPEN");
                  setmodalRISRetr(true);
                }}
                icon={FaUpload}
                title="Importer le RIS"
                subtitle="Relevé tous régimes"
                colors={{
                  primary: "rgb(124, 58, 237)",
                  secondary: "rgb(109, 40, 217)",
                  shadow: "rgba(124, 58, 237, 0.4)",
                  shadowHover: "rgba(124, 58, 237, 0.6)",
                  background: "linear-gradient(135deg, rgb(124, 58, 237) 0%, rgb(109, 40, 217) 100%)",
                }}
                decorativeIcon={{ type: "upload" }}
                style={{ width: "215px" }}
              />
              <ActionButton
                onClick={() => {
                  trackEvent("PERIODE", "MODAL_OPEN");
                  context.handleResetPeriodeRetraite(clientConjoint, "");
                  setmodalPeriodeRetr(true);
                }}
                icon={FaPlusCircle}
                title="Ajouter une période"
                subtitle="Période projetée ou passée"
                colors={{
                  primary: "#11998e",
                  secondary: "#0d7377",
                  shadow: "rgba(17, 153, 142, 0.4)",
                  shadowHover: "rgba(17, 153, 142, 0.6)",
                }}
                decorativeIcon={{ type: "calendar" }}
                style={{ width: "215px" }}
              />
              <ActionButton
                onClick={() => {
                  trackEvent("PARAM", "MODAL_OPEN");
                  setmodalParamRetrOpen(true);
                }}
                id="paramRetraite"
                icon={FaCogs}
                title="Paramètres"
                subtitle="Configuration retraite"
                colors={{
                  primary: "#e57373",
                  secondary: "#c62828",
                  shadow: "rgba(229, 115, 115, 0.4)",
                  shadowHover: "rgba(229, 115, 115, 0.6)",
                }}
                decorativeIcon={{ type: "settings" }}
                style={{ width: "215px" }}
              />
              <ActionButton
                onClick={toggleChatbot}
                icon={FaCommentDots}
                title="Assistant Alan"
                subtitle="Aide et conseils"
                colors={{
                  primary: "#f59e0b",
                  secondary: "#d97706",
                  shadow: "rgba(245, 158, 11, 0.4)",
                  shadowHover: "rgba(245, 158, 11, 0.6)",
                  background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                }}
                decorativeIcon={{ type: "help" }}
                style={{ width: "215px" }}
              />
            </div>
          </div>
          <div style={{ display: "flex", gap: 24, alignItems: "stretch", height: "613px" }}>
            <div style={{ flex: 1, minWidth: 0, position: "relative", display: "flex" }}>
              <div
                style={{
                  backgroundColor: "white",
                  borderRadius: "16px",
                  padding: "24px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                  border: "1px solid #f0f0f0",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  flex: 1,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "20px",
                    paddingBottom: "16px",
                    borderBottom: "2px solid #f0f0f0",
                  }}
                >
                  <div>
                    <h3
                      style={{
                        margin: 0,
                        fontSize: "14px",
                        fontWeight: 600,
                        color: "#333",
                        marginBottom: "4px",
                      }}
                    >
                      Périodes de carrière
                    </h3>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "12px",
                        color: "#666",
                      }}
                    >
                      Historique des activités professionnelles
                    </p>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <span
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        backgroundColor: "#f8f9fa",
                        padding: "6px 12px",
                        borderRadius: "20px",
                      }}
                    >
                      {context.state["Carriere" + clientConjoint]?.length} période(s)
                    </span>
                  </div>
                </div>
                <div
                  style={{
                    overflow: "auto",
                    flex: 1,
                    scrollbarWidth: "thin",
                    scrollbarColor: "#cbd5e1 #f1f5f9",
                    paddingRight: "12px",
                    marginRight: "4px",
                  }}
                  className="custom-scrollbar"
                >
                  {context.state["Carriere" + clientConjoint]?.map((Infos, Index) => (
                    <PeriodCard
                      key={Index}
                      period={Infos}
                      index={Index}
                      correspondanceActivite={CorrespondanceActivite}
                      onEdit={() => {
                        context.handleModifyDeletePeriodeRetraite(Infos.id, "Modifier", "", clientConjoint);
                        setmodalPeriodeRetr(true);
                      }}
                      onDelete={() => {
                        Dialogs.confirm("Vous êtes sur le point de supprimer la période.\nVoulez-vous continuer ?", "Suppression de la période", () => {
                          context.handleModifyDeletePeriodeRetraite(Infos.id, "Supprimer", "", clientConjoint);
                        });
                      }}
                      canDelete={Infos.id !== "CarriereActuelle"}
                    />
                  ))}
                </div>
              </div>
            </div>
            <div style={{ position: "relative", display: "flex" }}>
              <ModernReplacementChart resultat={ResultatTNS.state} context={context} clientConjoint={clientConjoint} />
            </div>
          </div>
        </div>
      </Column>
      <Modal
        width="75%"
        height="82%"
        title="Ajouter une période"
        icon={<FaGlobe />}
        visible={modalPeriodeRetr}
        onClose={() => {
          setmodalPeriodeRetr(false);
          returnToMenu();
        }}
        className="modal-ris-left"
      >
        <AjoutPeriodePageModal
          Outil=""
          ClientConjoint={clientConjoint}
          visible={modalPeriodeRetr}
          onClose={() => {
            setmodalPeriodeRetr(false);
            returnToMenu();
          }}
        />
      </Modal>
      <Modal
        width="85%"
        height="82%"
        title="Lecture du relevé de carrière"
        icon={<FaGlobe />}
        visible={modalRISRetr}
        onClose={() => {
          setmodalRISRetr(false);
          returnToMenu();
        }}
        className="modal-ris-left"
      >
        <AjoutRISPageModal
          Outil=""
          ClientConjoint={clientConjoint}
          visible={modalRISRetr}
          onClose={() => {
            setmodalRISRetr(false);
            returnToMenu();
          }}
          onRISEvent={(action) => {
            trackEvent("RIS", action);
          }}
        />
      </Modal>
      <RGProvider ClientConjoint={clientConjoint} visible={modalParamRetrOpen}>
        <RGContext.Consumer>
          {(RGCtx) => (
            <Modal
              width="75%"
              height="92%"
              title="Paramétrage de la retraite"
              icon={<FaGlobe />}
              visible={modalParamRetrOpen}
              onClose={() => {
                setmodalParamRetrOpen(false);
                returnToMenu();
              }}
              className="modal-ris-left"
            >
              <ParamRetraitePageModal
                Outil=""
                ClientConjoint={clientConjoint}
                visible={modalParamRetrOpen}
                onClose={() => {
                  setmodalParamRetrOpen(false);
                  returnToMenu();
                }}
              />
            </Modal>
          )}
        </RGContext.Consumer>
      </RGProvider>
      <CarriereChatbot />
    </>
  );
};

// Wrap with CarriereEventsProvider
const CarrierePageWithProvider = (props) => {
  return (
    <CarriereEventsProvider>
      <CarrierePage {...props} />
    </CarriereEventsProvider>
  );
};

export default CarrierePageWithProvider;
